import ApiService from '@/services/api.service'

const CountryService = {
  
    getCountries(){     
        return ApiService.get(`/Countries`);
    },

  }


  
  export default CountryService;